import { Box, Button, Paper, Stack, Typography } from '@ace-clublabs/shared-component-library';
import React from 'react';

export interface MarketingCardProps {
  image: string;
  title: string;
  content: string;
  buttonTitle: string;
  buttonOnClick: () => void;
  className?: string;
}

export const MarketingCard: (props: MarketingCardProps) => JSX.Element = ({
  image,
  title,
  content,
  buttonTitle,
  buttonOnClick,
  className,
}) => {
  return (
    <Paper elevation={8} sx={{ overflow: 'hidden', position: 'relative' }} className={`${className}-card`}>
      <Stack sx={{ height: '100%' }}>
        <Box>
          <img
            height={'88px'}
            width={'296px'}
            src={image}
            style={{ objectFit: 'cover' }}
            className={`${className}-image`}
          />
        </Box>
        <Stack
          sx={{
            padding: '1rem',
            justifyContent: 'space-between',
            flex: '1',
          }}
        >
          <Box minHeight={'7.875rem'}>
            <Typography
              variant="h6Medium"
              sx={{ fontWeight: '500', color: '#304C62' }}
              className={`${className}-title`}
            >
              {title}
            </Typography>
            <Typography
              variant="b2Regular"
              sx={{ marginTop: '16px', marginBottom: '16px', color: '#304C62' }}
              className={`${className}-content`}
            >
              {content}
            </Typography>
          </Box>
          <Button
            label={buttonTitle}
            size="small"
            variant="outlined"
            fullWidth
            onClick={buttonOnClick}
            className={`${className}-button`}
          />
        </Stack>
      </Stack>
    </Paper>
  );
};

export default MarketingCard;
